import {
  PhoneIcon,
  DocumentTextIcon,
  BriefcaseIcon,
  RocketLaunchIcon,
  ChatBubbleLeftRightIcon,
  CurrencyDollarIcon,
  ScaleIcon,
  TrophyIcon,
  UserGroupIcon,
  PencilIcon,
  ChatBubbleBottomCenterTextIcon,
  CalendarDaysIcon,
  BanknotesIcon,
} from '@heroicons/react/24/outline'
import {
  Gym,
  UserStar,
  Network,
  BrainResearch,
  HandCard,
  JournalPage,
  Group,
  PageEdit,
} from 'iconoir-react'
import { LinkedInIcon, TargetIcon } from './ProfessionalServices/icons'
import { CoachServicesCircle } from '~/components/icons/YnsIcon'

export const SERVICE_REQUEST_ICONS = {
  'ServiceRequest::OrientationCall': 'phone',
  'ServiceRequest::ResumeReview': 'document',
  'ServiceRequest::CoverLetterReview': 'document',
  'ServiceRequest::ResumeTailoring': 'document',
  'ServiceRequest::LinkedInReview': 'linkedin',
  'ServiceRequest::JobSearchStrategy': 'briefcase',
  'ServiceRequest::CareerPivotPlanning': 'target',
  'ServiceRequest::NetworkingStrategy': 'people',
  'ServiceRequest::InterviewPrep': 'interview',
  'ServiceRequest::MockInterview': 'chat',
  'ServiceRequest::NegotiationStrategy': 'dollar',
  'ServiceRequest::JobSearchBurnout': 'wellness',
  'ServiceRequest::OnboardingSupport': 'rocket',
  'ServiceRequest::RetirementSupport': 'retirement',
  'ServiceRequest::StrengthsAssessment': 'gym',
  'ServiceRequest::ExecutiveBio': 'pencil',
  'ServiceRequest::RecruiterGuidanceSupport': 'recruiting',
  'ServiceRequest::BoardSearch': 'network',
  'ServiceRequest::TargetCompanyResearch': 'target',
  'ServiceRequest::GeneralCheckIn': 'calendar',
  'ServiceRequest::TargetedResearch': 'target',
  'ServiceRequest::CliftonStrengths': 'brain',
  'ServiceRequest::BusinessCardCreation': 'handCard',
  'ServiceRequest::SalaryResearch': 'banknotes',
  'ServiceRequest::ResumeWriting': 'pageEdit',
}

export const icons = {
  phone: PhoneIcon,
  document: DocumentTextIcon,
  linkedin: LinkedInIcon,
  briefcase: BriefcaseIcon,
  target: TargetIcon,
  rocket: RocketLaunchIcon,
  people: UserGroupIcon,
  chat: ChatBubbleLeftRightIcon,
  dollar: CurrencyDollarIcon,
  wellness: ScaleIcon,
  retirement: TrophyIcon,
  recruiting: UserStar,
  gym: Gym,
  network: Network,
  pencil: PencilIcon,
  interview: ChatBubbleBottomCenterTextIcon,
  liaison: CoachServicesCircle,
  calendar: CalendarDaysIcon,
  brain: BrainResearch,
  banknotes: BanknotesIcon,
  handCard: HandCard,
  journal: JournalPage,
  group: Group,
  pageEdit: PageEdit,
  // Add more mappings as needed
  // Add custom icons manually as needed
}
